import axios, { AxiosResponse } from "axios";
import { call } from "redux-saga/effects";

interface GetIpResponse {
  ip: string;
}

export function* getIp(): Generator<
  ReturnType<typeof call>,
  string,
  AxiosResponse<GetIpResponse>
> {
  try {
    const responseIP: AxiosResponse<GetIpResponse> = yield call(
      axios.get,
      "https://api.ipify.org?format=json",
    );

    const ip = responseIP?.data?.ip;

    if (ip === "::1") return "127.0.0.1";
    return ip;
  } catch (error) {
    return "";
  }
}
